<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-4 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-cog mr-1"></i> Configurações
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <!-- Basic Information -->
        <div class="container mb-4 border-bottom">
            <section-default
                title="Informações"
                description="Aqui você pode encontrar as informações referentes a sua escola">

                <basic-information :can-edit="canEdit"></basic-information>

            </section-default>
        </div>



        <!--Audio category-->
        <div class="container my-4 border-bottom" v-if="canEdit">
            <section-default
                title="Categorias em áudios"
                description="Aqui você pode definir categorias para organizar os áudios na correção da redação">

                <b-card>
                    <div class="d-flex justify-content-between align-items-center">
                        <span>Categorias</span>
                        <button class="btn btn-link" @click="showModal">
                            Gerenciar
                        </button>
                    </div>
                </b-card>
                <audio-category></audio-category>

            </section-default>
        </div>


        <!-- Theme -->
        <div class="container my-4 borde-bottom" v-if="canEdit">
            <section-default
                title="Tema"
                description="Aqui você pode encontrar as informações referentes a identidade visual da sua escola">

                <update-theme></update-theme>

            </section-default>
        </div>

    </div>
</template>

<script>
import SectionDefault from '../../../components/SectionDefault.vue';
import BasicInformation from "./BasicInformation";
import UpdateTheme from "./UpdateTheme";
import AudioCategory from './AudioCategory.vue';

export default {
    components: {
        BasicInformation,
        UpdateTheme,
        SectionDefault,
        AudioCategory
    },
    props: ['canEdit'],
    methods: {

        showModal(){
            this.$root.$emit('manageAudioCategories')

        },
    }
}
</script>

<style scoped>

</style>
